import React from 'react'
import { StyledCalender } from 'components/CalendarPicker/Style/style'

const CalendarPicker = ({
  multiple = false,
  value = null,
  onCalenderChange,
  numberOfMonths = 1,
}) => {
  return (
    <StyledCalender
      multiple={multiple}
      numberOfMonths={numberOfMonths}
      value={value}
      onChange={onCalenderChange}
    />
  )
}

export default CalendarPicker
